/**
 * Tiny coloured pill that brands a row by platform.
 * Centralises the platform colour map so every page renders the same
 * iOS / Android / Web / YouTube / Instagram badge.
 */

import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { PLATFORM_COLORS } from '../../theme';

const LABELS = {
  ios:       'iOS',
  android:   'Android',
  web:       'Web',
  youtube:   'YouTube',
  instagram: 'Instagram',
  twitter:   'Twitter',
};

export default function PlatformChip({ platform, size = 'small', sx = {} }) {
  const key = (platform || '').toLowerCase();
  const color = PLATFORM_COLORS[key] || '#64748B';
  const label = LABELS[key] || platform || '?';
  return (
    <Chip
      label={label}
      size={size}
      sx={{
        bgcolor: alpha(color, 0.12),
        color,
        fontWeight: 700,
        border: `1px solid ${alpha(color, 0.3)}`,
        ...sx,
      }}
    />
  );
}
